// src/analytics-event-handler.ts
var isAnalyticsEventHandlerAvailable = () => typeof window !== "undefined" && Boolean(window?.AnalyticsEventHandler);
function analyticsEventHandler() {
  return {
    enabled: isAnalyticsEventHandlerAvailable(),
    sendMoEngageEvent: (eventName, payload) => window?.AnalyticsEventHandler?.sendMoEngageEvent?.(eventName, payload)
  };
}

export {
  analyticsEventHandler
};
